import { ChangeDetectorRef, Component, OnInit, ViewChild, ElementRef, HostListener, OnDestroy } from '@angular/core';
import { NgbModal, NgbModalRef, NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import * as feather from 'feather-icons';
import { ChartConfiguration } from 'chart.js';
import { FlatpickrInstance } from 'ng2-flatpickr/src/flatpickr-instance';
import {Telephone} from '../../../../../../models/client';
import {Observable, Subscription, throwError} from 'rxjs';
import {ClientService} from '../../../../../../services/Client/client.service';
import {ActivatedRoute, Router} from '@angular/router';
import {tap} from 'rxjs/operators';
import {Address, Email, Fournisseur} from '../../../../../../models/fournisseur';
import {FournisseurService} from '../../../../../../services/Fournisseur/fournisseur.service';
import {FournisseurEventService} from '../../../../../../services/Fournisseur/fournisseur-event.service';

@Component({
    selector: 'app-fr-detail-contenu-apercue',
    templateUrl: './fr-detail-contenu-apercue.component.html',
    styleUrls: ['./fr-detail-contenu-apercue.component.scss']
})
export class FrDetailContenuApercueComponent implements OnInit, OnDestroy {
    @ViewChild('addressModal') addressModal: any;
    @ViewChild('deletePhoneModal') deletePhoneModal: any;
    @ViewChild('deleteAddressModal', { static: true }) deleteAddressModal: any;
    @ViewChild('deleteEmailModal', { static: true }) deleteEmailModal: any;
    @ViewChild('flatpickr', { static: false }) flatpickr: any;
    @ViewChild('dateLabel', { static: false }) dateLabel: ElementRef;
    @ViewChild('datePickerContainer', { static: false }) datePickerContainer: ElementRef;

    /** Repositionne le calendrier au scroll / resize (les @HostListener ne doivent pas être sur un @ViewChild). */
    @HostListener('window:scroll')
    @HostListener('window:resize')
    onWindowScrollOrResize(): void {
        const wrap = this.flatpickr?.flatpickr as any;
        if (!wrap) {
            return;
        }
        const inst = (wrap.instance ?? wrap) as FlatpickrInstance | undefined;
        if (inst?.calendarContainer) {
            this.positionCalendar(inst);
        }
    }

    fournisseur: Fournisseur = {
        civilite: '',
        nom_entreprise: '',
        numero_identification_fiscale: '',
        site_web: '',
        station_id: 0,
        user_id: 0,
        identifiant_unique: null,
        emails: [],
        is_archive: false,
        telephones: [],
        adresses: [],
    };
    isPhoneAddMode = false;
    isPhoneEditMode = false;
    isEmailAddMode = false;
    isEmailEditMode = false;

    phoneToEdit: any = { type: 'mobile', num_tel_full: '' };
    emailToEdit: any = { email: '' };
    addr: Address = {
        type: 'facturation',
        adresse: '',
        pays: '',
        region: '',
        code_postal: '',
        station_id: 0,
        user_id: 0,
        fournisseur_id: 0,
    };
    private phoneNumberPattern: RegExp = /^[0-9]{8}$/;
    addressToDelete: Address | null = null;
    phoneToDelete: Telephone = { type: 'mobile', num_tel: '', code_pays: '+212', station_id: 0, user_id: 0, client_id: 0 };
    emailToDelete: Email = { email: '', user_id: 0, fournisseur_id: 0, station_id: 0 };
    deletePhoneIndex: number | null = null;
    deleteAddressIndex: number | null = null;
    deleteEmailIndex: number | null = null;
    isStep3Valid: boolean = false;
    isEditMode: boolean = false;
    editIndex: number | null = null;
    private modalRef: NgbModalRef | null = null;
    private repositionInterval: any = null;
    private subscriptions: Subscription[] = [];
    stationId: number = 0;
    userId: number = 0;
    isLoading: boolean = false;
    isAddMode: boolean = false;

    public DateRangeOptions = {
        altInput: false,
        mode: 'range',
        dateFormat: 'Y-m-d',
        defaultDate: ['2019-05-01', '2019-05-10'],
        enableTime: false,
        locale: {
            firstDayOfWeek: 1,
        },
        appendTo: undefined,
        onReady: (selectedDates: Date[], dateStr: string, instance: FlatpickrInstance) => {
            this.positionCalendar(instance);
        },
        onOpen: (selectedDates: Date[], dateStr: string, instance: FlatpickrInstance) => {
            this.positionCalendar(instance);
            this.repositionInterval = setInterval(() => {
                this.positionCalendar(instance);
            }, 100);
        },
        onClose: (selectedDates: Date[], dateStr: string, instance: FlatpickrInstance) => {
            if (this.repositionInterval) {
                clearInterval(this.repositionInterval);
                this.repositionInterval = null;
            }
        },
    };

    public barChart: ChartConfiguration<'bar'> = {
        type: 'bar',
        data: {
            datasets: [
                {
                    data: [500, 300, 400, 200, 600, 450, 350],
                    backgroundColor: 'rgba(255, 159, 67, 1)',
                    borderColor: 'transparent',
                    hoverBackgroundColor: 'rgba(255, 159, 67, 1)',
                    hoverBorderColor: 'rgba(255, 159, 67, 1)',
                    borderRadius: 6,
                    borderSkipped: false,
                    barPercentage: 0.5,
                    categoryPercentage: 0.4,
                },
            ],
            labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul'],
        },
        options: {
            elements: {
                bar: {
                    borderWidth: 2,
                    borderSkipped: 'bottom',
                },
            },
            responsive: true,
            maintainAspectRatio: false,
            animation: {
                duration: 500,
            },
            plugins: {
                legend: {
                    display: false,
                },
                tooltip: {
                    backgroundColor: '#ffffff',
                    titleColor: '#000000',
                    bodyColor: '#000000',
                    boxPadding: 4,
                },
            },
            scales: {
                x: {
                    display: true,
                    grid: {
                        display: true,
                        color: 'rgba(200, 200, 200, 0.2)',
                    },
                    ticks: {
                        color: '#6e6b7b',
                    },
                },
                y: {
                    display: true,
                    beginAtZero: true,
                    grid: {
                        color: 'rgba(200, 200, 200, 0.2)',
                    },
                    ticks: {
                        stepSize: 100,
                        maxTicksLimit: 7,
                        color: '#6e6b7b',
                    },
                },
            },
        },
    };

    constructor(
        private toastr: ToastrService,
        private cdr: ChangeDetectorRef,
        private modalService: NgbModal,
        private fournisseurService: FournisseurService,
        private route: ActivatedRoute,
        private router: Router,
        private fournisseurEventService: FournisseurEventService
    ) {}

    ngOnInit(): void {
        this.loadUserData();
        const fournisseurId = this.route.parent?.snapshot.paramMap.get('reference');
        if (!fournisseurId || fournisseurId === 'add') {
            this.isAddMode = true;
            this.fournisseur = {
                civilite: 'avant',
                nom_entreprise: '',
                numero_identification_fiscale: '',
                site_web: '',
                station_id: this.stationId,
                user_id: this.userId,
                identifiant_unique: null,
                emails: [],
                is_archive: false,
                telephones: [{ type: 'mobile', num_tel: '', code_pays: '+212', station_id: this.stationId, user_id: this.userId, fournisseur_id: 0 }],
                adresses: [],
            };
        } else {
            this.loadFournisseurData(fournisseurId);
        }
    }

    ngOnDestroy(): void {
        if (this.repositionInterval) {
            clearInterval(this.repositionInterval);
            this.repositionInterval = null;
        }
        this.subscriptions.forEach((sub) => sub.unsubscribe());
    }

    private loadUserData(): void {
        try {
            const user = JSON.parse(localStorage.getItem('currentUser') || '{}');
            this.stationId = user?.stations?.[0]?.id || 0;
            this.userId = user?.id || 0;
            if (!this.stationId) {
                this.toastr.error('Aucune station trouvée. Veuillez créer une station.', 'Erreur');
                this.router.navigate(['/create-station']);
            }
            if (!this.userId) {
                this.toastr.error('Aucun utilisateur trouvé. Veuillez vous connecter.', 'Erreur');
                this.router.navigate(['/login']);
            }
        } catch (error) {
            this.toastr.error('Erreur lors de la récupération des données utilisateur.', 'Erreur');
            this.stationId = 0;
            this.userId = 0;
        }
    }

    private loadFournisseurData(fournisseurId: string): void {
        this.isLoading = true;
        const sub = this.fournisseurService.getFournisseurById(fournisseurId).subscribe({
            next: (fournisseurData) => {
                let emails: Email[] = [];
                if (fournisseurData.emails) {
                    if (Array.isArray(fournisseurData.emails) && typeof fournisseurData.emails[0] === 'string') {
                        emails = fournisseurData.emails.map(email => ({
                            email: email as string,
                            user_id: this.userId,
                            client_id: fournisseurData.id || 0,
                            station_id: this.stationId,
                            id: undefined,
                            created_at: undefined,
                            updated_at: undefined
                        } as Email));
                    } else {
                        emails = (fournisseurData.emails as Email[]).map(email => ({
                            id: email.id || undefined,
                            email: email.email || '',
                            user_id: this.userId,
                            client_id: fournisseurData.id || 0,
                            station_id: this.stationId,
                            created_at: email.created_at || undefined,
                            updated_at: email.created_at || undefined
                        } as Email));
                    }
                }
                if (emails.length === 0) {
                    emails = [];
                }

                let adresses: Address[] = fournisseurData.adresses?.map((addr) => ({
                    ...addr,
                    station_id: this.stationId,
                    user_id: this.userId,
                    client_id: fournisseurData.id || 0
                })) || [];

                this.fournisseur = {
                    ...fournisseurData,
                    emails,
                    telephones: fournisseurData.telephones?.map((tel) => ({
                        ...tel,
                        num_tel: tel.num_tel || '',
                        code_pays: tel.code_pays || '+212',
                        station_id: this.stationId,
                        user_id: this.userId,
                        client_id: fournisseurData.id || 0
                    })) || [],
                    adresses,
                };
                this.isLoading = false;
                //this.toastr.success('Données du fournisseur chargées', 'Succès');
                this.refreshFeatherIcons();
                this.cdr.detectChanges();
            },
            error: (error) => {
                this.isLoading = false;
                const errorMessage = error.error?.errors?.map((err: any) => err.message).join(', ') || 'Erreur lors du chargement des données du fournisseur';
                this.toastr.error(errorMessage, 'Erreur');
                this.router.navigate(['/tiers/fournisseurs']);
            },
        });
        this.subscriptions.push(sub);
    }

    refreshFeatherIcons(): void {
        setTimeout(() => {
            feather.replace();
            this.cdr.detectChanges();
        }, 0);
    }

    openFlatpickr(): void {
        if (this.flatpickr && this.flatpickr.flatpickr) {
            this.flatpickr.flatpickr.open();
        } else {
            this.toastr.error('Erreur : Calendrier non initialisé.', 'Erreur', {
                positionClass: 'toast-top-right',
                toastClass: 'toast ngx-toastr',
                closeButton: true,
            });
        }
    }

    positionCalendar(instance: FlatpickrInstance): void {
        if (this.dateLabel && this.dateLabel.nativeElement && instance.calendarContainer) {
            const labelRect = this.dateLabel.nativeElement.getBoundingClientRect();
            const container = instance.calendarContainer;
            const leftOffset = -10;
            const top = labelRect.bottom + window.scrollY + 5;
            const left = labelRect.left + window.scrollX + leftOffset;

            setTimeout(() => {
                container.style.position = 'absolute';
                container.style.top = `${top}px`;
                container.style.left = `${left}px`;
                container.style.zIndex = '10001';
                this.cdr.detectChanges();
            }, 0);
        } else {
            this.toastr.error('Erreur : Positionnement du calendrier échoué.', 'Erreur', {
                positionClass: 'toast-top-right',
                toastClass: 'toast ngx-toastr',
                closeButton: true,
            });
        }
    }

    onFlatpickrReady(event: [FlatpickrInstance, HTMLElement]): void {
        this.toastr.success('Calendrier initialisé.', 'Succès', {
            positionClass: 'toast-top-right',
            toastClass: 'toast ngx-toastr',
            closeButton: true,
        });
    }

    onDateChange(selectedDates: Date[]): void {
        if (selectedDates.length === 2) {
            const [startDate, endDate] = selectedDates;
            this.toastr.success(`Plage de dates sélectionnée : ${startDate.toLocaleDateString('fr-FR')} - ${endDate.toLocaleDateString('fr-FR')}`, 'Succès', {
                positionClass: 'toast-top-right',
                toastClass: 'toast ngx-toastr',
                closeButton: true,
            });
        }
    }

    addPhone(): void {
        if (this.fournisseur.telephones.length < 5) {
            this.fournisseur.telephones = [
                ...this.fournisseur.telephones,
                {
                    type: 'mobile',
                    num_tel: '',
                    code_pays: '+216',
                    station_id: this.stationId,
                    user_id: this.userId,
                    fournisseur_id: this.fournisseur.id || 0,
                }
            ];
            this.refreshFeatherIcons();
        } else {
            this.toastr.error('Vous ne pouvez pas ajouter plus de 5 numéros de téléphone.', 'Erreur');
        }
    }

    openDeletePhoneModal(index: number): void {
        if (this.fournisseur.telephones.length > 1) {
            this.phoneToDelete = { ...this.fournisseur.telephones[index] };
            this.deletePhoneIndex = index;
            try {
                this.modalRef = this.modalService.open(this.deletePhoneModal, { centered: true, size: 'md', ariaLabelledBy: 'modal-title' });
                this.refreshFeatherIcons();
            } catch (error) {
                this.toastr.error('Erreur lors de l’ouverture du modal de suppression de téléphone.', 'Erreur', {
                    positionClass: 'toast-top-right',
                    toastClass: 'toast ngx-toastr',
                    closeButton: true,
                });
            }
        } else {
            this.toastr.error('Vous devez conserver au moins un numéro de téléphone.', 'Erreur', {
                positionClass: 'toast-top-right',
                toastClass: 'toast ngx-toastr',
                closeButton: true,
            });
        }
    }

    confirmDeletePhone(): void {
        if (this.deletePhoneIndex !== null) {
            const updatedPhones = this.fournisseur.telephones.filter((_, i) => i !== this.deletePhoneIndex);
            this.fournisseur.telephones = updatedPhones;
            this.updateClient(updatedPhones, this.fournisseur.emails, this.fournisseur.adresses).subscribe({
                next: () => {
                    this.toastr.success('Numéro de téléphone supprimé avec succès.', 'Succès');
                    this.closeDeletePhoneModal();
                    this.emitFournisseurUpdate(); // Emit update
                    this.refreshFeatherIcons();
                },
                error: (error) => {
                    const errorMessage = error.error?.errors?.map((err: any) => err.message).join(', ') || 'Erreur lors de la suppression du numéro de téléphone.';
                    this.toastr.error(errorMessage, 'Erreur', {
                        positionClass: 'toast-top-right',
                        toastClass: 'toast ngx-toastr',
                        closeButton: true,
                    });
                    this.closeDeletePhoneModal();
                    this.fournisseur.telephones = [...this.fournisseur.telephones];
                    this.refreshFeatherIcons();
                },
            });
        }
    }

    closeDeletePhoneModal(): void {
        if (this.modalRef) {
            this.modalRef.close();
            this.modalRef = null;
            this.phoneToDelete = null;
            this.deletePhoneIndex = null;
            this.refreshFeatherIcons();
        }
    }

    openDeleteAddressModal(index: number): void {
        if (this.fournisseur.adresses.length > 1 && this.fournisseur.adresses[index]) {
            this.addressToDelete = { ...this.fournisseur.adresses[index] };
            this.deleteAddressIndex = index;
            try {
                this.modalRef = this.modalService.open(this.deleteAddressModal, { centered: true, size: 'md', ariaLabelledBy: 'modal-title' });
                this.refreshFeatherIcons();
            } catch (error) {
                this.toastr.error('Erreur lors de l’ouverture du modal de suppression d’adresse.', 'Erreur', {
                    positionClass: 'toast-top-right',
                    toastClass: 'toast ngx-toastr',
                    closeButton: true,
                });
            }
        } else {
            this.toastr.error('Vous devez conserver au moins une adresse.', 'Erreur', {
                positionClass: 'toast-top-right',
                toastClass: 'toast ngx-toastr',
                closeButton: true,
            });
            this.toastr.error('Ajoutez une autre adresse pour activer la suppression.', 'Erreur', {
                positionClass: 'toast-top-right',
                toastClass: 'toast ngx-toastr',
                closeButton: true,
            });
        }
    }

    confirmDeleteAddress(): void {
        if (this.deleteAddressIndex !== null) {
            const updatedAddresses = this.fournisseur.adresses.filter((_, i) => i !== this.deleteAddressIndex);
            this.fournisseur.adresses = updatedAddresses;
            this.updateClient(this.fournisseur.telephones, this.fournisseur.emails, updatedAddresses).subscribe({
                next: () => {
                    this.toastr.success('Adresse supprimée avec succès.', 'Succès');
                    this.closeDeleteAddressModal();
                    this.refreshFeatherIcons();
                },
                error: (error) => {
                    const errorMessage = error.error?.errors?.map((err: any) => err.message).join(', ') || 'Erreur lors de la suppression de l’adresse.';
                    this.toastr.error(errorMessage, 'Erreur', {
                        positionClass: 'toast-top-right',
                        toastClass: 'toast ngx-toastr',
                        closeButton: true,
                    });
                    this.closeDeleteAddressModal();
                    this.fournisseur.adresses = [...this.fournisseur.adresses];
                    this.refreshFeatherIcons();
                },
            });
        }
    }

    closeDeleteAddressModal(): void {
        if (this.modalRef) {
            this.modalRef.close();
            this.modalRef = null;
            this.addressToDelete = null;
            this.deleteAddressIndex = null;
            this.refreshFeatherIcons();
        }
    }

    addEmail(): void {
        if (this.fournisseur.emails.length < 5) {
            this.fournisseur.emails = [...this.fournisseur.emails, {
                email: '',
                user_id: this.userId,
                client_id: this.fournisseur.id || 0,
                station_id: this.stationId
            } as Email];
            this.refreshFeatherIcons();
        } else {
            this.toastr.error('Vous ne pouvez pas ajouter plus de 5 adresses e-mail.', 'Erreur', {
                positionClass: 'toast-top-right',
                toastClass: 'toast ngx-toastr',
                closeButton: true,
            });
        }
    }

    openDeleteEmailModal(index: number): void {
        if (this.fournisseur.emails.length > 1 && this.fournisseur.emails[index]) {
            this.emailToDelete = { ...this.fournisseur.emails[index] };
            this.deleteEmailIndex = index;
            try {
                this.modalRef = this.modalService.open(this.deleteEmailModal, { centered: true, size: 'md', ariaLabelledBy: 'modal-title' });
                this.refreshFeatherIcons();
            } catch (error) {
                this.toastr.error('Erreur lors de l’ouverture du modal de suppression d’email.', 'Erreur', {
                    positionClass: 'toast-top-right',
                    toastClass: 'toast ngx-toastr',
                    closeButton: true,
                });
            }
        } else {
            this.toastr.error('Vous devez conserver au moins une adresse e-mail.', 'Erreur', {
                positionClass: 'toast-top-right',
                toastClass: 'toast ngx-toastr',
                closeButton: true,
            });
            this.toastr.error('Ajoutez une autre adresse e-mail pour activer la suppression.', 'Erreur', {
                positionClass: 'toast-top-right',
                toastClass: 'toast ngx-toastr',
                closeButton: true,
            });
        }
    }

    openPhoneModal(index: number | null, isAddMode: boolean): void {
        if (isAddMode && this.fournisseur.telephones.length >= 5) {
            this.toastr.error('Vous ne pouvez pas ajouter plus de 5 numéros de téléphone.', 'Erreur', {
                positionClass: 'toast-top-right',
                toastClass: 'toast ngx-toastr',
                closeButton: true,
            });
            return;
        }

        if (!isAddMode && this.fournisseur.telephones.length <= 1) {
            this.toastr.error('Vous devez conserver au moins un numéro de téléphone.', 'Erreur', {
                positionClass: 'toast-top-right',
                toastClass: 'toast ngx-toastr',
                closeButton: true,
            });
            return;
        }

        this.isPhoneAddMode = isAddMode;
        this.deletePhoneIndex = isAddMode ? null : index;
        this.phoneToDelete = isAddMode
            ? { type: 'mobile', num_tel: '', code_pays: '+216', station_id: this.stationId, user_id: this.userId, client_id: this.fournisseur.id || 0 }
            : { ...this.fournisseur.telephones[index!] };

        try {
            this.modalRef = this.modalService.open(this.deletePhoneModal, { centered: true, size: 'md', ariaLabelledBy: 'modal-title' });
            this.refreshFeatherIcons();
        } catch (error) {
            this.toastr.error('Erreur lors de l’ouverture du modal de téléphone.', 'Erreur', {
                positionClass: 'toast-top-right',
                toastClass: 'toast ngx-toastr',
                closeButton: true,
            });
        }
    }

    openEmailModal(index: number | null, isAddMode: boolean): void {
        if (isAddMode && this.fournisseur.emails.length >= 5) {
            this.toastr.error('Vous ne pouvez pas ajouter plus de 5 adresses e-mail.', 'Erreur', {
                positionClass: 'toast-top-right',
                toastClass: 'toast ngx-toastr',
                closeButton: true,
            });
            return;
        }
        if (!isAddMode && this.fournisseur.emails.length <= 1) {
            this.toastr.error('Vous devez conserver au moins une adresse e-mail.', 'Erreur', {
                positionClass: 'toast-top-right',
                toastClass: 'toast ngx-toastr',
                closeButton: true,
            });
            return;
        }

        this.isEmailAddMode = isAddMode;
        this.deleteEmailIndex = isAddMode ? null : index;
        this.emailToDelete = isAddMode
            ? { email: '', user_id: this.userId, fournisseur_id: this.fournisseur.id || 0, station_id: this.stationId }
            : { ...this.fournisseur.emails[index!] };

        try {
            this.modalRef = this.modalService.open(this.deleteEmailModal, { centered: true, size: 'md', ariaLabelledBy: 'modal-title' });
            this.refreshFeatherIcons();
        } catch (error) {
            this.toastr.error('Erreur lors de l’ouverture du modal d’email.', 'Erreur', {
                positionClass: 'toast-top-right',
                toastClass: 'toast ngx-toastr',
                closeButton: true,
            });
        }
    }

    confirmDeleteEmail(): void {
        if (this.deleteEmailIndex !== null) {
            const updatedEmails = this.fournisseur.emails.filter((_, i) => i !== this.deleteEmailIndex);
            this.fournisseur.emails = updatedEmails;
            this.updateClient(this.fournisseur.telephones, updatedEmails, this.fournisseur.adresses).subscribe({
                next: () => {
                    this.toastr.success('Adresse e-mail supprimée avec succès.', 'Succès');
                    this.closeDeleteEmailModal();
                    this.emitFournisseurUpdate(); // Emit update
                    this.refreshFeatherIcons();
                },
                error: (error) => {
                    const errorMessage = error.error?.errors?.map((err: any) => err.message).join(', ') || 'Erreur lors de la suppression de l’adresse e-mail.';
                    this.toastr.error(errorMessage, 'Erreur', {
                        positionClass: 'toast-top-right',
                        toastClass: 'toast ngx-toastr',
                        closeButton: true,
                    });
                    this.closeDeleteEmailModal();
                    this.fournisseur.emails = [...this.fournisseur.emails];
                    this.refreshFeatherIcons();
                },
            });
        }
    }

    closeDeleteEmailModal(): void {
        if (this.modalRef) {
            this.modalRef.close();
            this.modalRef = null;
            this.emailToDelete = null;
            this.deleteEmailIndex = null;
            this.refreshFeatherIcons();
        }
    }

    deleteEmail(index: number): void {
        this.openEmailModal(index, false);
    }

    validateStep3(): void {
        this.isStep3Valid = !!this.addr.type && !!this.addr.pays && !!this.addr.region && !!this.addr.code_postal && !!this.addr.adresse;
    }

    openModal(): void {
        this.isEditMode = false;
        this.editIndex = null;
        this.addr = {
            type: 'facturation',
            adresse: '',
            pays: '',
            region: '',
            code_postal: '',
            station_id: this.stationId,
            user_id: this.userId,
            fournisseur_id: this.fournisseur.id || 0,
        };
        try {
            this.modalRef = this.modalService.open(this.addressModal, { centered: true, size: 'lg', ariaLabelledBy: 'modal-title' });
            this.validateStep3();
            this.refreshFeatherIcons();
        } catch (error) {
            this.toastr.error('Erreur lors de l’ouverture du modal d’ajout d’adresse.', 'Erreur', {
                positionClass: 'toast-top-right',
                toastClass: 'toast ngx-toastr',
                closeButton: true,
            });
        }
    }

    dismissModal(): void {
        if (this.modalRef) {
            this.modalRef.dismiss('Cancel click');
            this.modalRef = null;
            this.refreshFeatherIcons();
        }
    }

    saveAddress(): void {
        if (!this.isStep3Valid) {
            this.toastr.error('Veuillez remplir tous les champs obligatoires.', 'Erreur', {
                positionClass: 'toast-top-right',
                toastClass: 'toast ngx-toastr',
                closeButton: true,
            });
            return;
        }

        let updatedAddresses: Address[];
        if (this.isEditMode && this.editIndex !== null) {
            updatedAddresses = [...this.fournisseur.adresses];
            updatedAddresses[this.editIndex] = { ...this.addr };
        } else if (this.fournisseur.adresses.length < 5) {
            updatedAddresses = [...this.fournisseur.adresses, { ...this.addr }];
        } else {
            this.toastr.error('Vous ne pouvez pas ajouter plus de 5 adresses.', 'Erreur', {
                positionClass: 'toast-top-right',
                toastClass: 'toast ngx-toastr',
                closeButton: true,
            });
            return;
        }

        this.fournisseur.adresses = updatedAddresses;
        this.updateClient(this.fournisseur.telephones, this.fournisseur.emails, updatedAddresses).subscribe({
            next: (response) => {
                if (this.modalRef) {
                    try {
                        this.modalRef.close('Save click');
                        this.modalRef = null;
                    } catch (error) {
                    }
                }
                this.toastr.success(this.isEditMode ? 'Adresse modifiée avec succès.' : 'Adresse ajoutée avec succès.', 'Succès');
                this.refreshFeatherIcons();
                this.cdr.detectChanges();
            },
            error: (error) => {
                const errorMessage = error?.message || error?.error?.message || 'Erreur inconnue lors de la mise à jour de l’adresse.';
                this.toastr.error(errorMessage, 'Erreur', {
                    positionClass: 'toast-top-right',
                    toastClass: 'toast ngx-toastr',
                    closeButton: true,
                });
                if (this.isEditMode && this.editIndex !== null) {
                    this.fournisseur.adresses = [...this.fournisseur.adresses];
                } else {
                    this.fournisseur.adresses = this.fournisseur.adresses.slice(0, -1);
                }
                this.cdr.detectChanges();
            },
            complete: () => {
            }
        });
    }

    editAddress(index: number): void {
        this.isEditMode = true;
        this.editIndex = index;
        this.addr = { ...this.fournisseur.adresses[index] };
        try {
            this.modalRef = this.modalService.open(this.addressModal, { centered: true, size: 'lg', ariaLabelledBy: 'modal-title' });
            this.validateStep3();
            this.refreshFeatherIcons();
        } catch (error) {
            this.toastr.error('Erreur lors de l’ouverture du modal de modification d’adresse.', 'Erreur', {
                positionClass: 'toast-top-right',
                toastClass: 'toast ngx-toastr',
                closeButton: true,
            });
        }
    }

    addClient(): Observable<Fournisseur> {
        const fournisseurData: any = {
            civilite: this.fournisseur.civilite || 'Homme',
            nom_entreprise: this.fournisseur.nom_entreprise || '',
            station_id: this.stationId,
            user_id: this.userId,
            numero_identification_fiscale: this.fournisseur.numero_identification_fiscale,
            site_web: this.fournisseur.site_web,
            identifiant_unique: this.fournisseur.identifiant_unique || null,
            emails: this.fournisseur.emails
                .filter(email => email.email)
                .map(email => email.email),
            is_archive: this.fournisseur.is_archive || false,
            created_at: new Date().toISOString(),
            updated_at: new Date().toISOString(),
            telephones: this.fournisseur.telephones.map((phone) => ({
                type: phone.type === 'telephonePortable' ? 'mobile' : phone.type || 'mobile',
                num_tel: phone.num_tel.replace(phone.code_pays || '', '').trim() || '',
                code_pays: phone.code_pays || '+216',
                station_id: this.stationId,
                user_id: this.userId,
                client_id: 0,
                created_at: new Date().toISOString(),
                updated_at: new Date().toISOString(),
            })),
            adresses: this.fournisseur.adresses.map((addr) => ({
                type: addr.type === 'facturation' ? 'adresse_fac' : addr.type === 'livraison' ? 'adresse_li' : addr.type,
                pays: addr.pays === 'France' ? 'FR' : addr.pays === 'Belgique' ? 'BE' : addr.pays === 'Suisse' ? 'CH' : addr.pays === 'Maroc' ? 'MA' : addr.pays,
                region: addr.region || null,
                code_postal: addr.code_postal,
                adresse: addr.adresse,
                station_id: this.stationId,
                user_id: this.userId,
                client_id: 0,
                created_at: new Date().toISOString(),
                updated_at: new Date().toISOString(),
            })),
        };

        this.isLoading = true;
        return this.fournisseurService.addFournisseur(fournisseurData).pipe(
            tap({
                next: (response) => {
                    this.fournisseur = {
                        ...response,
                        emails: Array.isArray(response.emails) ? response.emails.map((email: string | Email) => ({
                            email: typeof email === 'string' ? email : email.email || '',
                            user_id: this.userId,
                            client_id: response.id || 0,
                            station_id: this.stationId,
                            id: typeof email === 'string' ? undefined : email.id,
                            created_at: typeof email === 'string' ? undefined : email.created_at,
                            updated_at: typeof email === 'string' ? undefined : email.updated_at
                        } as Email)) : [],
                        telephones: Array.isArray(response.telephones) ? response.telephones.map((tel: any) => ({
                            ...tel,
                            num_tel: tel.num_tel || '',
                            code_pays: tel.code_pays || '+216',
                            station_id: this.stationId,
                            user_id: this.userId,
                            client_id: response.id || 0
                        })) : [],
                        adresses: Array.isArray(response.adresses) ? response.adresses.map((addr: any) => ({
                            ...addr,
                            station_id: this.stationId,
                            user_id: this.userId,
                            client_id: response.id || 0
                        })) : [],
                    };
                    this.isAddMode = false;
                    this.isLoading = false;
                    this.toastr.success(`Fournisseur ${fournisseurData.nom_entreprise} ajouté`, 'Succès');
                    this.router.navigate(['/tiers/fournisseurs/details', response.identifiant_unique || response.id]);
                    this.refreshFeatherIcons();
                    this.cdr.detectChanges();
                },
                error: (error) => {
                    this.isLoading = false;
                    const errorMessage = error.error?.errors?.map((err: any) => err.message).join(', ') || 'Erreur lors de l\'ajout du client';
                    this.toastr.error(errorMessage, 'Erreur');
                    this.cdr.detectChanges();
                    throw error;
                },
            })
        );
    }

    updateClient(telephones: Telephone[], emails: Email[], adresses: Address[]): Observable<Fournisseur> {
        if (!this.fournisseur.id && !this.isAddMode) {
            this.toastr.error('ID de client manquant pour la mise à jour.', 'Erreur');
            return throwError(() => new Error('Missing client ID'));
        }

        const fournisseurData: any = {
            id: this.fournisseur.id || undefined,
            numero_identification_fiscale: this.fournisseur.numero_identification_fiscale || undefined,
            site_web: this.fournisseur.site_web,
            civilite: this.fournisseur.civilite || 'avant',
            nom_entreprise: this.fournisseur.nom_entreprise || '',
            station_id: this.stationId,
            user_id: this.userId,
            identifiant_unique: this.fournisseur.identifiant_unique || null,
            emails: emails
                .filter(email => email.email)
                .map(email => email.email),
            is_archive: this.fournisseur.is_archive || false,
            created_at: this.fournisseur.created_at || undefined,
            updated_at: new Date().toISOString(),
            telephones: telephones.map((phone) => ({
                id: phone.id || undefined,
                type: phone.type === 'telephonePortable' ? 'mobile' : phone.type || 'mobile',
                num_tel: phone.num_tel.replace(phone.code_pays || '', '').trim() || '',
                code_pays: phone.code_pays || '+216',
                station_id: this.stationId,
                user_id: this.userId,
                client_id: this.fournisseur.id || 0,
                created_at: phone.created_at || new Date().toISOString(),
                updated_at: new Date().toISOString(),
            })),
            adresses: adresses.map((addr) => ({
                id: addr.id || undefined,
                type: addr.type === 'facturation' ? 'adresse_fac' : addr.type === 'livraison' ? 'adresse_li' : addr.type,
                pays: addr.pays === 'France' ? 'FR' : addr.pays === 'Belgique' ? 'BE' : addr.pays === 'Suisse' ? 'CH' : addr.pays === 'Maroc' ? 'MA' : addr.pays,
                region: addr.region || null,
                code_postal: addr.code_postal,
                adresse: addr.adresse,
                station_id: this.stationId,
                user_id: this.userId,
                client_id: this.fournisseur.id || 0,
                created_at: addr.created_at || new Date().toISOString(),
                updated_at: new Date().toISOString(),
            })),
        };

        this.isLoading = true;
        if (this.isAddMode) {
            return this.addClient();
        } else {
            return this.fournisseurService.updateFournisseur(this.fournisseur.id!, fournisseurData).pipe(
                tap({
                    next: (response) => {
                        this.loadFournisseurData(String(this.fournisseur.id!));
                        this.isLoading = false;
                        this.refreshFeatherIcons();
                        this.cdr.detectChanges();
                    },
                    error: (error) => {
                        this.isLoading = false;
                        const errorMessage = error.error?.errors?.map((err: any) => err.message).join(', ') || 'Erreur lors de la mise à jour du client';
                        this.toastr.error(errorMessage, 'Erreur');
                        this.cdr.detectChanges();
                        throw error;
                    },
                })
            );
        }
    }

    validateAndSavePhone(index: number): void {
        const phone = this.fournisseur.telephones[index];
        const phoneInput = phone.num_tel.trim();
        if (!phoneInput) {
            this.toastr.error('Veuillez entrer un numéro de téléphone.', 'Erreur', {
                positionClass: 'toast-top-right',
                toastClass: 'toast ngx-toastr',
                closeButton: true,
            });
            return;
        }
        if (!this.phoneNumberPattern.test(phoneInput)) {
            this.toastr.error('Le numéro de téléphone doit contenir exactement 8 chiffres.', 'Erreur', {
                positionClass: 'toast-top-right',
                toastClass: 'toast ngx-toastr',
                closeButton: true,
            });
            return;
        }

        this.fournisseur.telephones[index] = {
            ...phone,
            num_tel: phoneInput,
            code_pays: phone.code_pays || '+216',
        };
        this.updateClient(this.fournisseur.telephones, this.fournisseur.emails, this.fournisseur.adresses).subscribe({
            next: () => {
                this.toastr.success('Numéro de téléphone mis à jour avec succès.', 'Succès');
                this.emitFournisseurUpdate(); // Emit update
                this.refreshFeatherIcons();
            },
            error: (error) => {
                const errorMessage = error.error?.errors?.map((err: any) => err.message).join(', ') || 'Erreur lors de la mise à jour du numéro de téléphone.';
                this.toastr.error(errorMessage, 'Erreur', {
                    positionClass: 'toast-top-right',
                    toastClass: 'toast ngx-toastr',
                    closeButton: true,
                });
                this.fournisseur.telephones[index] = { ...phone };
                this.refreshFeatherIcons();
            },
        });
    }

    validateAndSaveEmail(index: number): void {
        const email = this.fournisseur.emails[index];
        if (email && email.email && email.email.match(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/)) {
            this.updateClient(this.fournisseur.telephones, this.fournisseur.emails, this.fournisseur.adresses).subscribe({
                next: () => {
                    this.toastr.success('Adresse e-mail mise à jour avec succès.', 'Succès');
                    this.emitFournisseurUpdate(); // Emit update
                    this.refreshFeatherIcons();
                },
                error: (error) => {
                    const errorMessage = error.error?.errors?.map((err: any) => err.message).join(', ') || 'Erreur lors de la mise à jour de l’adresse e-mail.';
                    this.toastr.error(errorMessage, 'Erreur', {
                        positionClass: 'toast-top-right',
                        toastClass: 'toast ngx-toastr',
                        closeButton: true,
                    });
                },
            });
        } else if (!email.email) {
            this.deleteEmail(index);
        } else {
            this.toastr.error('Veuillez entrer une adresse e-mail valide.', 'Erreur', {
                positionClass: 'toast-top-right',
                toastClass: 'toast ngx-toastr',
                closeButton: true,
            });
        }
    }

    private emitFournisseurUpdate(): void {
        this.fournisseurEventService.updateFournisseur(this.fournisseur);
    }

    openPhoneAddModal() {
        this.isPhoneAddMode = true;
        this.isPhoneEditMode = false;
        this.phoneToEdit = { type: 'mobile', num_tel_full: '' };
        this.modalRef = this.modalService.open(this.deletePhoneModal, { centered: true, size: 'md' });
    }

    openPhoneEditModal(index: number) {
        this.isPhoneAddMode = false;
        this.isPhoneEditMode = true;
        const p = this.fournisseur.telephones[index];
        this.phoneToEdit = { index, type: p.type, num_tel_full: p.code_pays + p.num_tel };
        this.modalRef = this.modalService.open(this.deletePhoneModal, { centered: true, size: 'md' });
    }

    openPhoneDeleteModal(index: number) {
        this.isPhoneAddMode = false;
        this.isPhoneEditMode = false;
        this.phoneToEdit = { index };
        this.modalRef = this.modalService.open(this.deletePhoneModal, { centered: true, size: 'md' });
    }

    confirmPhoneAction() {
        if (this.isPhoneAddMode || this.isPhoneEditMode) {
            const full = this.phoneToEdit.num_tel_full?.trim();
            if (!full || !/^\+[0-9]{1,3}[0-9]{8,}$/.test(full)) {
                this.toastr.error('Numéro invalide (ex: +21612345678)');
                return;
            }
            const code_pays = full.match(/^\+[0-9]{1,3}/)![0];
            const num_tel = full.replace(code_pays, '');

            if (this.isPhoneAddMode) {
                this.fournisseur.telephones.push({ type: this.phoneToEdit.type, code_pays, num_tel });
            } else {
                this.fournisseur.telephones[this.phoneToEdit.index] = { type: this.phoneToEdit.type, code_pays, num_tel };
            }
        } else {
            this.fournisseur.telephones.splice(this.phoneToEdit.index, 1);
        }

        this.updateClient(this.fournisseur.telephones, this.fournisseur.emails, this.fournisseur.adresses).subscribe({
            next: () => {
                this.toastr.success(this.isPhoneAddMode ? 'Ajouté' : this.isPhoneEditMode ? 'Modifié' : 'Supprimé');
                this.closePhoneModal();
            }
        });
    }

    closePhoneModal() {
        if (this.modalRef) this.modalRef.close();
        this.isPhoneAddMode = this.isPhoneEditMode = false;
        this.phoneToEdit = { type: 'mobile', num_tel_full: '' };
    }

// === Email ===
    openEmailAddModal() {
        this.isEmailAddMode = true;
        this.isEmailEditMode = false;
        this.emailToEdit = { email: '' };
        this.modalRef = this.modalService.open(this.deleteEmailModal, { centered: true, size: 'md' });
    }

    openEmailEditModal(index: number) {
        this.isEmailAddMode = false;
        this.isEmailEditMode = true;
        this.emailToEdit = { index, email: this.fournisseur.emails[index].email };
        this.modalRef = this.modalService.open(this.deleteEmailModal, { centered: true, size: 'md' });
    }

    openEmailDeleteModal(index: number) {
        this.isEmailAddMode = false;
        this.isEmailEditMode = false;
        this.emailToEdit = { index };
        this.modalRef = this.modalService.open(this.deleteEmailModal, { centered: true, size: 'md' });
    }

    confirmEmailAction() {
        const email = this.emailToEdit.email?.trim();
        if ((this.isEmailAddMode || this.isEmailEditMode) && !email?.match(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i)) {
            this.toastr.error('Email invalide');
            return;
        }

        if (this.isEmailAddMode) {
            this.fournisseur.emails.push({ email });
        } else if (this.isEmailEditMode) {
            this.fournisseur.emails[this.emailToEdit.index].email = email;
        } else {
            this.fournisseur.emails.splice(this.emailToEdit.index, 1);
        }

        this.updateClient(this.fournisseur.telephones, this.fournisseur.emails, this.fournisseur.adresses).subscribe({
            next: () => {
                this.toastr.success(this.isEmailAddMode ? 'Ajouté' : this.isEmailEditMode ? 'Modifié' : 'Supprimé');
                this.closeEmailModal();
            }
        });
    }

    closeEmailModal() {
        if (this.modalRef) this.modalRef.close();
        this.isEmailAddMode = this.isEmailEditMode = false;
        this.emailToEdit = { email: '' };
    }
}
